// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SalesProcess from '../components/SalesProcess';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    salesProcessInformation: state.salesProcessConfig.salesProcessInformation,
    orderStateMessages: state.salesProcessConfig.orderStateMessages,
    error: state.salesProcessConfig.error,
    isFetchingSalesProcessInformation:
      state.salesProcessConfig.isFetchingSalesProcessInformation,
    isFetchingOrderStateMessages:
      state.salesProcessConfig.isFetchingOrderStateMessages,
    isSaving: state.salesProcessConfig.isSaving,
    updateSuccess: state.salesProcessConfig.updateSuccess,
    store: state.store.store,
    contact: state.information.contact,
    user: state.auth.user,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(SalesProcess);
